module.exports = __webpack_public_path__ + "static/media/tabungan_pegawai.889b9607.png";